import React, { Component } from "react";
import { connect } from "react-redux";

//Components
import { withStyles } from "@material-ui/core/styles";

//MUI
import { Card, Grid } from "@material-ui/core";

function mapStateToProps(state) {
  return {
    state
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Styles
const styles = theme => ({
  root: {
    heading: "2em"
  }
});

class Schedule extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render() {
    // eslint-disable-next-line
    const { classes } = this.props;

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={6} md={3}>
            <Card>{/*  */}</Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>{/*  */}</Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>{/*  */}</Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>{/*  */}</Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Schedule));



// WEBPACK FOOTER //
// ./src/pages/user_dashboard/dashboard_tabs/Schedule.js